import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import InputWithUnit from '@/components/InputWithUnit.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { getEvseModelInfo, upsertEvseModel } from '@/api/evses'
import SelectOperator from '@/components/SelectOperator.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import FormRulesFactory from '@/common/formRules'


import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'EvseModelDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  evseModelInfo: {
    type: Object,
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const evseModelFormRules = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorID', 'standard', 'evseCurrentType', 'useVehicleType', 'networking'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(['model', 'vendor'], 'inputEmpty', 'inputInvalid'),
  ...FormRulesFactory.generateCustomRules(['ratedPower'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 1000,
  }),
  ...FormRulesFactory.generateCustomRules(
    ['ratedCurrentMin', 'ratedCurrentMax'],
    'inputEmpty',
    'inputInvalid',
    {
      type: 'number',
      min: 1,
      max: 500,
    },
  ),
  ...FormRulesFactory.generateCustomRules(['ratedVoltage'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 2000,
  }),
})
const {
  evseOperationTypes,
  connectorTypes,
  evseStandards,
  evseCurrentTypes,
  useVehicleTypes,
  evseNetworkingModes,
  evsePhases,
} = useProtocolEnums()

const { tl, t } = useI18nTl('Evses')



let subsForm = ref()
const record = ref<Record<string, any>>({})
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}
const showDialog = computed({
  get: () => {
    // subsForm.value?.clearValidate()
    clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  await subsForm.value?.validate()
  record.value.ratedPower = Number(
    record.value.ratedPower.substring(0, record.value.ratedPower.length - 2),
  )
  record.value.ratedPower = record.value.ratedPower * 1000
  record.value.ratedVoltage = Number(
    record.value.ratedVoltage.substring(0, record.value.ratedVoltage.length - 1),
  )
  record.value.ratedCurrentMin = Number(
    record.value.ratedCurrentMin.substring(0, record.value.ratedCurrentMin.length - 1),
  )
  record.value.ratedCurrentMax = Number(
    record.value.ratedCurrentMax.substring(0, record.value.ratedCurrentMax.length - 1),
  )
  if (record.value.modelId == '') {
    record.value.modelId = '0'
  }
  if (record.value.stationID == '') {
    record.value.stationID = '0'
  }

  upsertEvseModel({ model: record.value })
    .then((res: any) => {
      ElMessage.success(t(`Base.createSuccess`))
      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
      ElMessage.error(t(`Base.createSuccess`))
    })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value.id = props.evseModelInfo?.id
      record.value.evseSN = props.evseModelInfo?.evseSN
      record.value.operatorID = props.evseModelInfo?.operatorID
      record.value.stationID = props.evseModelInfo?.stationID
      record.value.connectorNum = props.evseModelInfo?.connectorNumber
      record.value.operationType = props.evseModelInfo?.operationType
      record.value.connectorType = props.evseModelInfo?.connectorType
      record.value.modelId = props.evseModelInfo?.modelId
      record.value.model = props.evseModelInfo?.model
      record.value.vendor = props.evseModelInfo?.vendor
      record.value.product = props.evseModelInfo?.product
      record.value.standard = props.evseModelInfo?.standard
      record.value.phase = props.evseModelInfo?.phase
      record.value.evseCurrentType = props.evseModelInfo?.evseCurrentType
      record.value.useVehicleType = props.evseModelInfo?.useVehicleType
      record.value.networking = props.evseModelInfo?.networking
      record.value.ratedPower = props.evseModelInfo?.ratedPower / 1000 + 'KW'
      record.value.ratedVoltage = props.evseModelInfo?.ratedVoltage + 'V'
      record.value.ratedCurrentMin = props.evseModelInfo?.ratedCurrentMin + 'A'
      record.value.ratedCurrentMax = props.evseModelInfo?.ratedCurrentMax + 'A'
    } else {
      record.value = {}
    }
  },
  { immediate: true },
)

const selectionEvseModelChanged = (modelId: string) => {
  // 在这里处理选中后的逻辑，例如发送网络请求、更新数据等
  if (modelId && modelId != '0' && modelId != '') {
    // console.log('选中的模型ID：', modelId)
    getEvseModelInfo({
      modelId: modelId,
    })
      .then((res: any) => {
        // console.log('选中的模型：', res)
        record.value.model = res.model.model
        record.value.vendor = res.model.vendor
        record.value.product = res.model.product
        record.value.standard = res.model.standard
        record.value.evseCurrentType = res.model.evseCurrentType
        record.value.useVehicleType = res.model.useVehicleType
        record.value.networking = res.model.networking
        record.value.phase = res.model.phase
        record.value.ratedPower = String(res.model.ratedPower / 1000) + 'KW'
        record.value.ratedVoltage = String(res.model.ratedVoltage) + 'V'
        record.value.ratedCurrentMin = String(res.model.ratedCurrentMin) + 'A'
        record.value.ratedCurrentMax = String(res.model.ratedCurrentMax) + 'A'
      })
      .catch((error: any) => {
        console.error('Error fetching table data:', error)
      })
  }
}
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(tl)('editEvseModel') : _unref(tl)('addEvseModel'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[13] || (_cache[13] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: evseModelFormRules.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: record.value.operatorID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.operatorID) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('model'),
                    prop: "model",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.model) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('vendor'),
                    prop: "vendor",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.vendor,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.vendor) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('product'),
                    prop: "product"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.product,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.product) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('standard'),
                    prop: "standard",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.standard,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.standard) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseStandards), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('phase')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.phase,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.phase) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evsePhases), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('evseCurrentType'),
                    prop: "evseCurrentType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.evseCurrentType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.evseCurrentType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseCurrentTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('useVehicleType'),
                    prop: "useVehicleType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.useVehicleType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.useVehicleType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useVehicleTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('networking'),
                    prop: "networking",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.networking,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.networking) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseNetworkingModes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('ratedPower'),
                    prop: "ratedPower",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedPower,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.ratedPower) = $event)),
                        "number-placeholder": "7",
                        units: [{ label: 'KW', value: 'KW' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('ratedVoltage'),
                    prop: "ratedVoltage",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedVoltage,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.ratedVoltage) = $event)),
                        "number-placeholder": "380",
                        units: [{ label: 'V', value: 'V' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('minCurrent'),
                    prop: "ratedCurrentMin",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedCurrentMin,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.ratedCurrentMin) = $event)),
                        "number-placeholder": "8",
                        units: [{ label: 'A', value: 'A' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('maxCurrent'),
                    prop: "ratedCurrentMax",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedCurrentMax,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((record.value.ratedCurrentMax) = $event)),
                        "number-placeholder": "40",
                        units: [{ label: 'A', value: 'A' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})